import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import VideoShowcase from './components/VideoShowCase';  // Zamiast Team
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
    return (
        <div className="App">
            <Header />
            <Hero />
            <Services />
            <About />
            <VideoShowcase />  {/* Nowa sekcja z wideo */}
            <Testimonials />
            <Contact />
            <Footer />
        </div>
    );
}

export default App;